import React, { useState, useCallback } from 'react';
import LazyLoad from 'react-lazyload';

import { cleanVideoUrl, youtubeVariable } from '../../ui/helpers';
import { VideoWrapper } from './styles';

interface IProps {
  videoUrl: string;
  aspectRatio: number;
  className?: string;
  delay?: number;
  lazy?: boolean;
}

const Youtube = ({ videoUrl, aspectRatio, className, delay = 0, lazy = true }: IProps) => {
  const VideoRef = useCallback(ref => {
    if (ref !== null) {
      if (delay === 0) videoLoader(ref);
      else {
        let timer = setTimeout(() => videoLoader(ref), delay * 1000);
        return () => {
          clearTimeout(timer);
        };
      }
    }
  }, []);

  const videoLoader = ref => {
    ref.src = ref.getAttribute('data-src');
    ref.onload = ref.style.opacity = 1;
  };

  return lazy ? (
    <VideoWrapper
      as={LazyLoad}
      height={'100%'}
      once
      offset={100}
      ratio={aspectRatio}
      className={`${className ? className : 'video'}`}>
      <picture>
        <source
          srcSet={`https://i.ytimg.com/vi_webp/${youtubeVariable(videoUrl)}/hqdefault.webp`}
          type="image/webp"
        />
        <source
          srcSet={`https://i.ytimg.com/vi_webp/${youtubeVariable(videoUrl)}/maxresdefault.webp`}
          type="image/webp"
        />
        <img
          className="ytcover"
          src={`https://i.ytimg.com/vi/${youtubeVariable(videoUrl)}/maxresdefault.jpg`}
          alt={`YouTube video thumbnail`}
        />
      </picture>

      <iframe
        ref={VideoRef}
        title={`YouTube Video: ${videoUrl}`}
        data-src={cleanVideoUrl(videoUrl)}></iframe>
    </VideoWrapper>
  ) : (
    <VideoWrapper ratio={aspectRatio} className={`${className ? className : 'video'}`}>
      <picture>
        <source
          srcSet={`https://i.ytimg.com/vi_webp/${youtubeVariable(videoUrl)}/hqdefault.webp`}
          type="image/webp"
        />
        <source
          srcSet={`https://i.ytimg.com/vi_webp/${youtubeVariable(videoUrl)}/maxresdefault.webp`}
          type="image/webp"
        />
        <img
          className="ytcover"
          src={`https://i.ytimg.com/vi/${youtubeVariable(videoUrl)}/maxresdefault.jpg`}
          alt={`YouTube video thumbnail`}
        />
      </picture>

      <iframe
        ref={VideoRef}
        title={`YouTube Video: ${videoUrl}`}
        src={cleanVideoUrl(videoUrl)}
        data-src={cleanVideoUrl(videoUrl)}></iframe>
    </VideoWrapper>
  );
};

export default Youtube;
